module.exports = {
  pleaseWait: "Iltimos, kuting",
  loading: "Yuklanmoqda",
  Billing: "Xaridlar",
  billingTips: "Yaqinda amalga oshirgan xaridlaringiz",
  ID: "ID",
  FAQ: "Ko‘p beriladigan savollar",
  TC: "Qoidalar va shartlar",
  Copyright: "© 2026 Barcha huquqlar himoyalangan",
  GenerateImage: "Tasvir yaratish",
  generateTips1: "AI asosidagi tasvir generatori tasavvurni haqiqatga aylantirib, bir necha soniya ichida hayratlanarli sanʼat asarlari, illyustratsiyalar va fotosuratlarni yaratadi. AI yordamida ijodkorligingizni oching va o‘zingizni yangi usullarda ifoda eting. Cheksiz imkoniyatlarni kashf qiling — noyob marketing materiallarini yaratishdan tortib, chiroyli sanʼat asarlarigacha, barchasi tengsiz qulaylik va samaradorlik bilan",
  generateTips2: "Quyida bir nechta so‘z kiriting va SnapAI matnni qanday qilib ajoyib sanʼat asariga aylantirishini tomosha qiling",
  Prompt: "Ko‘makchi maslahat",
  PromptTips1: "AI ga nimani yaratish kerakligini ko‘rsating",
  PromptTips2: "Maslahatlar: kayfiyat va yoritishni tasvirlab bering. Qo‘shimcha tavsiyalar olish uchun maslahatlar sahifasiga qarang",
  PromptTips3: "Eslatma: AI baʼzan ko‘rsatmalarga to‘liq amal qilmasligi mumkin va AI hisoblashni bilmaydi",
  Generate: "Yaratish",
  ChancesLeft: "Qolgan urinishlar",
  BuyChances: "Ko‘proq urinishlar xarid qilish",
  generateImageTips1: "Nimani yaratmoqchi ekaningizni kiriting",
  generatePromptsTips1: "Tasvirda nimani bo‘lishini xohlamasligingizni kiriting",
  indexTips1: "Kundalik bepul urinishlar <br /> mavjud",
  indexTips2: "Funksiyani tanlang",
  ImageRestorer: "Fotosuratlarni tiklash",
  Continue: "Davom etish",
  language0: "Til",
  language: "Tilni tanlang",
  languageTips: "Tilni bu yerda tanlang",
  Submit: "Tasdiqlash",
  change: "Saqlash",
  lang_1: "English",
  lang_3: "O'zbekcha",
  lang_2: "Русский",
  Login: "Kirish",
  Logout: "Chiqish",
  getCode: "Qayta yuborish",
  loginTips: "Telefon raqamini kiriting",
  profile: "Profil",
  phoneNumber: "Telefon raqami",
  SubscribedSince: "Obuna sanasi",
  RemainingChances: "Qolgan urinishlar",
  cgtips2: "Kuniga atigi 1500 so‘m, <br /> obuna bo‘lish uchun OK tugmasini bosing",
  OK: "OK",
  PictureRestorer: "Fotosuratlarni tiklash",
  PictureTips1: "AI yordamida tasvirlarni tiklang, yaxshilang va to‘g‘irlang. SnapAI eng so‘nggi tadqiqotlarga asoslanib, tirnalishlarni avtomatik ravishda olib tashlaydi, ranglar va yuzlarni yaxshilaydi hamda shikastlangan fotosuratlarni qimmatli xotiralarga aylantiradi. Bizning bepul xizmatimiz rangli hamda oq-qora fotosuratlarni tiklaydi",
  Upload: "Yuklash",
  PictureTips2: "Fotosuratda tirnalishlar bormi?",
  Restore: "Tiklash",
  uploadTips: "Iltimos, fotosuratni yuklang",
  PurchaseChances: "Urinishlarni xarid qilish",
  History: "Tarix",
  purchaseTips1: "Qolgan urinishlar",
  purchaseTips2: "Bir martalik xarid",
  Daily: "Kundalik obuna",
  Weekly: "Haftalik obuna",
  OneTime: "Bir martalik obuna",
  Purchase: "Xarid qilish",
  DailyKyats: "1500 so‘m",
  Subscribe: "Obuna bo‘lish",
  purchaseTips3: "Iltimos, nechta <strong> URINISH </strong> xarid qilishni tanlang",
  BuyNow: "Hozir xarid qilish",
  logout: "Chiqish",
  petTitle1: "AI anime uy hayvonlari",
  petTitle2: "Uslubni tanlang",
  petContent1: "Sevimli uy hayvoningiz fotosuratini anime uslubidagi g‘aroyib asarga aylantiring. Hayvonlarni sevuvchilar va anime ishqibozlari uchun juda mos. SnapAI mo‘ynali do‘stlaringizni o‘zgartirishning quvnoq va shaxsiylashtirilgan usulini taklif etadi",
  sexTitle1: "AI anime selfi",
  sexTitle2: "Jinsni tanlang",
  sexContent1: "Matnli ko‘rsatmalar asosida anime uslubidagi fotosuratlarni yaratib, tasavvuringizni jonlantiradi. Anime muxlisi, hikoyachi yoki dizayner bo‘lishingizdan qatʼi nazar, AI anime fotosuratlar sizga AI ni o‘ziga xos tasavvuringiz bilan uyg‘unlashtirib, yorqin va yuqori sifatli anime vizuallarni oson yaratish imkonini beradi",
  sexContent2: "Quyidagi uslubni tanlang va SnapAI matnni ajoyib san'at asariga aylantirishini tomosha qiling",
  Female: "Ayol",
  Male: "Erkak",
  Style1: "Uslub 1",
  Style2: "Uslub 2",
  Style3: "Uslub 3",
  Comic: "Komiks",
  Disney: "Disney",
  Ghibli: "Ghibli",
  Animalanime: "Anime selfi",
  HumanAnime: "Anime personaj",
  Guidance: "Qo‘llanma",
  PetAnime: "Anime uy hayvonlari",
  landTips1: "Ajoyib fotosuratlar yarating va",
  landTips2: "KATTA SOVRINLARNI YUTIB OLING!",
  landTips3: "SnapAI bilan tasavvuringizni jonlantiring! Ajoyib fotosuratlar generatsiyasidan tortib badiiy durdonalargacha — SnapAI sizga ilgari bo‘lmagan darajada vizual sanʼat asarlarini yaratish imkonini beradi. Cheksiz imkoniyatlar olamiga sho‘ng‘ing",
  show401tip: "Balans yetarli emas",
  show400dailytip: "Vaqt limiti oshib ketdi, sovrinlar yutib olish uchun qisqa raqam 88800 ga “AID” yuboring",
  register: "Ro‘yxatdan o‘tish",
  invitation: "Do‘stni taklif qilish",
  invitationTips: "Quyidagi havola orqali taklifni nusxalab yuboring",
  InviteNow: "Taklif qilish",
  copySuccess: "Muvaffaqiyatli nusxalandi",
  CopySucceeded: "Muvaffaqiyatli nusxalandi",
  process: "Jarayonda",
  downTips1: "Iltimos, havolani brauzerga nusxalab joylashtiring va yuklang",
  copyLink: "Havolani nusxalash",
  free: "Bepul",
  aiAnimeTitle: "AI anime juftlikda",
  aiAnimeCt1: "Asl fotosuratlaringizni anime uslubiga aylantiring va romantik lahzalaringizga yanada ko‘proq quvonch qo‘shing. Anime ishqibozi yoki dizayner bo‘lishingizdan qat’i nazar, juftlikdagi AI anime ilg‘or AI texnologiyalarini xotiralaringiz bilan uyg‘unlashtirib, yuqori sifatli anime tasvirlarni oson yaratish imkonini berad",
  aiAnimeCt2: "Quyidan uslubni tanlang, asl fotosuratingizni yuklang va SnapAI yoqimli xotiralaringizni qanday qilib hayratlanarli sanʼat asarlariga aylantirishini tomosha qiling",
  comingsoonT: "Tez kunda",
  SubscribePackage: "Obuna bo‘lish",
  landfont1: "Fotosuratlarni hayratlanarli anime sanʼatiga aylantiring",
  landfont2: "Juftlikdagi fotosuratlaringizni chiroyli anime personajlarga aylantiring",
  landfont3: "Chiroyli tasvirlar yaratish uchun so‘rov yozing",
  landfont4: "AI sehridan foydalanib, uy hayvonlaringizni yoqimli anime personajlarga aylantiring",
  landfont5: "AI asosidagi fotosuratlarni tiklash yordamida xotiralaringizni qayta jonlantiring",
  SmartCutout: "Aqlli kesib olish",
  letgo: "Tanlash!",
  IpIMage: "ID foto",
  IpIMageTip: "ID yoki shaxsni tasdiqlovchi hujjat uchun fotosurat kerakmi? Biz yordam beramiz",
  IpIMage_content: "ID fotosurati uchun yuklanadigan dastlabki tasvir yuzni hech qanday to‘sqinliklarsiz (sochlar, ko‘zoynak va hokazo) aniq ko‘rsatishi, yelkalar esa bir tekisda bo‘lishi kerak. Aks holda, generatsiya muvaffaqiyatsiz bo‘lishi mumkin",
  snapbot: "SnapBot",
  snapbot_hi: "Salom, men SnapBotman",
  help_today: "Bugun sizga qanday yordam bera olaman",
  think_ip: "🤖 O‘ylayapman...",
  Coloring_old_photos: "Tasvirlarga qayta rang berish",
  Coloring_old_photos_tips: "Eski fotosuratlaringizdagi ranglarni tiklang \n" +
    "va xotiralaringizni qayta jonlantiring. Bizning AI asosidagi vositamiz \n" +
    "tasvirlarni avtomatik tahlil qiladi va tabiiy rang ohanglarini qo‘shadi, \n" +
    "asl nusxa jozibasini saqlagan holda \n" +
    "vizual jozibadorligini oshiradi. \n",
  Coloring_old_photos_tips2: "AI asosidagi rangni tuzatish yordamida eski fotosuratlaringizni tiklang",
  BgFusion: "Fonini almashtirish",
  BgFusion_tips2: "Kerakli fonni tanlab, fotosuratingizni sozlang",
  BgFusion_tips: "Kerakli fonni tanlab, fotosuratingizni sozlang. \n" +
    "AI asl fonni almashtiradi \n" +
    "va tasviringizni yangi fonga tabiiy tarzda moslashtiradi",
  Upload_bg: "Fon yuklash",
  Upload_pt: "Selfi yuklash",
  Recolor: "Qayta rang berish",
  snapbotTips1: "Tezkor qidiruv natijalari",
  snapbotTips2: "Tabiiy tilni qayta ishlash",
  snapbotTips3: "Katta ma’lumotlarni tahlil qilish",
  snapbotTips4: "AI asosidagi algoritmlar",
  snapbotInput1: "SnapBot bilan boshlash uchun shu yerga bosing",
  white: "Oq",
  blue: "Havorang",
  '1 inch': "35×45 mm",
  '2 inches': "50×50 mm",
  landTips11: "Ajoyib fotosuratlar yarating va",
  ChangeHairstyle: "Soch turmagini o‘zgartirish sehri",
  ChangeHairstyle_short: "Orzu qilgan soch turmaklarini sinab ko‘ring",
  ChangeHairstyle_content_1: "SnapAI soch turmagini o‘zgartirish funksiyasini taklif etadi, bu foydalanuvchilarga real vaqt rejimida yoki yuklangan fotosuratlarda turli xil soch kesimlarini sinab ko‘rish imkonini beradi. Ushbu funksiya foydalanuvchining yuz chizg‘ilarini tahlil qilish uchun AI texnologiyalaridan foydalanadi va yuz shakli, didi hamda uslubiga mos keladigan soch turmaklarini taklif etadi. Foydalanuvchilar yengil o‘zgarishlardan tortib jasur va keskin transformatsiyalargacha turli obrazlarni sinab ko‘rib, haqiqiy o‘zgarishlarga qaror qilishdan oldin virtual ko‘rinishni ko‘rishlari mumkin",
  ChangeHairstyle_content_2: "Quyida yoqqan soch turmagini tanlang va o‘z fotosuratingizni qo‘shing",
  Result: "Natija",
  Original: "Asl",
  unsub_tip: "Obunani yoqish uchun qisqa raqam 88800 ga “OFF AID” yuboring",
  sub_tip: "Obuna bo‘lish uchun qisqa raqam 88800 ga “AID” yuboring",
  longHairEffects: "Uzun soch effekti",
  longHairEffects_tip: "Uzun soch effektini sinab ko‘ring! U sizga tabiiy va jozibador ko‘rinish beradi. Ushbu effekt yordamida siz uzun soch bilan qanday ko‘rinishda bo‘lishingizni ko‘rishingiz mumkin. \n" +
    "Silliq va yaltirab turadi \n" +
    "Uzun va tabiiy \n" +
    "Har qanday libosga mukammal mos keladi. Uzun soch effekti bilan siz har kuni eng yaxshi ko‘rinishda bo‘lasiz",
  VIDEO: "VIDEO",
  style: 'Uslub',
  pic_size_limit :"Rasmlar 5MB dan oshmasligi kerak",
  login_tip:"«SMS kodini olish» tugmasini bosish orqali siz <a href='https://mobiuz.snapai.asia' style='text-decoration: underline;color: white'>https://mobiuz.snapai.asia</a> veb-saytida kirish xizmatiga obunani amalga oshirasiz, bubilan Siz allaqachon 18 yoshga to'lganligingiz va shartlari <a href='/#/termsAndCondition' style='text-decoration: underline;color: white'>Foydalanuvchi bitimiga</a> bilan tanishganligingiz va ularning shartlari hamda taqdim etilishiga roziekanligingizni tasdiqlaysiz. Obuna narxi: kuniga 1500 so'm. (QQS bilan)",

  Trending:'Trendda',
  Face_Magic:'Yuz Sehri',
  AI_Studio:'AI Studiya',
  Home:'Bosh sahifa',
  unsubscribe:'Obunani bekor qilish',
  Back:'Orqaga',
  Chances:'Imkoniyatlar',
  Setting:'Sozlamalar',
  Menu:'Menyu',
  New:'Yangi',
  image_max_size:"Fayl hajmi 5MB dan oshgan",
  file_max_size:"Fayl hajmi 1MB dan oshgan",
  new_chat:"Yangi chat",
  file:"Fayl",
  image:"Rasm",
  invalid_image_format:"noto‘g‘ri fayl formati",
  Shoot_same_video:"Video yaratish",
  aiVividScene:"Yorqin AI Sahna",
  aiVividScene_desc:"Yorqin AI sahna bilan har qanday kayfiyat yoki fasl uchun mukammal surat yarating! Yuzingizning aniq fotosuratini yuklang va turli fonlar, uslublar hamda rang ohanglarini darhol sinab ko‘ring. O‘zingizni yozgi plyajga, yorqin shahar manzarasiga, yomg‘irli ko‘chaga yoki istalgan fantastik olamga ko‘chiring — sayohatsiz!",
  image_video:'Rasmni videoga',
  image_video_tip:"Ushbu funksiya fotosuratni 1–3 daqiqalik animatsion videoga aylantiradi, tabiiy yuz ifodalari va harakatlarni qo‘shib, tasvirni jonlantiradi. Foydalanuvchilar avval yaratilgan videolarni Tarix bo‘limida ko‘rishlari mumkin.",
  image_video_input:"Yaratmoqchi bo‘lgan fotosuratning uslubi va ko‘rinishini tasvirlab bering.",
  word_video:'Matnni videoga',
  word_video_tip:"Ushbu funksiya yozilgan matningizni AI texnologiyalari yordamida istalgan uslub va ifodani aks ettirgan holda jonli va dinamik videoga aylantiradi. Video yaratish 1–3 daqiqa vaqt olishi mumkin, shuningdek avval yaratilgan videolarni Tarix bo‘limida ko‘rishingiz mumkin.",
  word_video_input:"Yaratmoqchi bo‘lgan videoning uslubi va ko‘rinishini tasvirlab bering.",
  get_sms_code:"SMS kodini olish",


}



// WEBPACK FOOTER //
// ./src/assets/i18n/wz.js